export const isOverTimeCoupon = (value: number, isExpired: boolean) => {
  return isExpired && value < Date.now();
};
